import { render, staticRenderFns } from "./declarationInformation.vue?vue&type=template&id=4f957099&scoped=true&"
import script from "./declarationInformation.vue?vue&type=script&lang=js&"
export * from "./declarationInformation.vue?vue&type=script&lang=js&"
import style0 from "./declarationInformation.vue?vue&type=style&index=0&id=4f957099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f957099",
  null
  
)

export default component.exports